import { useShallow } from "zustand/shallow";

import { useGenomeViewerStore } from "../../../../store/store.ts";
import type { MinimalItem } from "../../../../types.ts";

export const useGroup = <T extends MinimalItem>(memberItem?: T) =>
  useGenomeViewerStore(
    useShallow((state) => {
      const track = memberItem ? state.tracks.get(memberItem.trackId) : undefined;
      const group = track ? state.trackGroups.get(track.groupId) : undefined;
      return { group, track };
    }),
  );
